import store from '@/store'

export const DEFAULT_FAVICON = '/arpoone.svg'
export const DEFAULT_TAB_TITLE = 'Arpoone'

const setPageAttributes = (config) => {
  const favicon = config?.logoUrl || DEFAULT_FAVICON
  const tabTitle = config?.brandName || DEFAULT_TAB_TITLE

  updateFavicon(favicon)
  updateTabTitle(tabTitle)
}

const updateFavicon = (favicon) => {
  let link = document.querySelector("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = favicon
}

const updateTabTitle = (title) => {
  document.title = title
}

const handleWhitelabelConfig = async (isDefaultHost, isWhitelabelConfigFresh, to, next) => {
  try {
    const shouldGetWhitelabelByOrgId = to.params.organizationId || isDefaultHost

    if (shouldGetWhitelabelByOrgId && !to.params.organizationId) {
      setPageAttributes()
      return
    }

    if (!isDefaultHost && isWhitelabelConfigFresh && !store.state.whitelabel.whitelabelConfig) {
      throw new Error()
    }

    const dispatchAction = shouldGetWhitelabelByOrgId ? 'getWhitelabelConfigByOrganizationId' : 'getWhitelabelConfig'

    if (!isWhitelabelConfigFresh) {
      const response = await store.dispatch(`whitelabel/${dispatchAction}`, to.params.organizationId)

      if (!response.data.data) {
        if (!isDefaultHost) {
          const responseDefault = await store.dispatch(`whitelabel/getWhitelabelConfig`)
          if (!responseDefault.data.data) {
            throw new Error()
          }
        } else {
          throw new Error()
        }
      }
    }

    setPageAttributes(store.state.whitelabel.whitelabelConfig)
  } catch (error) {
    setPageAttributes()
    if (!isDefaultHost && to.name !== 'error') {
      return next({ name: 'error' })
    }
  }
}

export default handleWhitelabelConfig
